export default {
  "header": {
    "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بارے میں"])},
    "log": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لاگ ان کریں / رجسٹر کریں۔"])},
    "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لاگ آوٹ"])},
    "manage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انتظام"])},
    "music": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["موسیقی"])}
  },
  "home": {
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بہترین نئی ریلیز کو سننا شروع کریں۔"])},
    "listen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["زبردست موسیقی سنیں !"])}
  },
  "mainContent": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["گانے"])}
  },
  "mySongs": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["میرے گانے"])}
  },
  "sondDetails": {
    "comments": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["No Comments"]), _normalize(["1 Comment"]), _normalize([_interpolate(_named("count")), " Comments"])])}
  },
  "upload": {
    "drop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اپنی فائلیں یہاں چھوڑ دیں۔"])},
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اپ لوڈ کریں۔"])}
  }
}